import { render, staticRenderFns } from "./printTicket.vue?vue&type=template&id=1f1bee3a&scoped=true&"
import script from "./printTicket.vue?vue&type=script&lang=js&"
export * from "./printTicket.vue?vue&type=script&lang=js&"
import style0 from "./printTicket.vue?vue&type=style&index=0&id=1f1bee3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1bee3a",
  null
  
)

export default component.exports